<div class="w-100">
  <div class="d-flex gap-3 align-items-center flex-wrap">
    <ng-container *ngIf="!readOnly">
      <input
        #fileInput
        (change)="onUploadFile($event)"
        [hidden]="true"
        accept="application/pdf,image/*"
        name="files"
        type="file"
      />

      <button
        (click)="fileInput.click()"
        color="primary"
        mat-raised-button
        type="button"
      >
        {{ "SHARED.UPLOAD_OPERATING_LICENSE" | translate }}
      </button>
    </ng-container>

    <a
      *ngIf="(operatingLicense$ | async) && siteId"
      target="_blank"
      [href]="operatingLicense$ | async"
    >
      Működési engedély
    </a>
    <a
      *ngIf="fileInStore && !siteId"
      (click)="openLocalFile()"
      href="javascript:void(0);"
    >
      Működési engedély
    </a>
  </div>

  <div *ngIf="isUploading$ | async" class="w-100 mt-4" style="height: 4px">
    <mat-progress-bar
      mode="determinate"
      [value]="uploadProgress$ | async"
    ></mat-progress-bar>
  </div>
</div>
